// import { variableNormalizer } from "@/utils/graphql";

export const getDegrees = () => {
  return {
    name: "getDegrees",
    ql: {
      query: `
      {
        getDegrees {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
        }
      }`
    }
  }
};

export const getProjects = () => {
  return {
    name: "getProjects",
    ql: {
      query: `
      {
        getProjects {
          id
          title: nameLocal
          nameEng
          nameLocal
        }
      }`
    }
  }
};

export const getFaculties = () => {
  return {
    name: "getFaculties",
    ql: {
      query: `
      {
        getFaculties {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
        }
      }`
    }
  }
};

export const getDepartments = () => {
  return {
    name: "getDepartments",
    ql: {
      query: `
      {
        getDepartments {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
        }
      }`
    }
  }
};

export const getPrefixes = () => {
  return {
    name: "getPrefixes",
    ql: {
      query: `
      {
        getPrefixes {
          id
          title: nameLocal
          nameLocal
          nameEng
          nameShortLocal
          nameShortEng
        }
      }`
    }
  }
};

export const getCurriculums = () => {
  return {
    name: "getCurriculums",
    ql: {
      query: `
      {
        getCurriculums {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
          certNameLocal
          certNameEng
          certShortNameLocal
          certShortNameEng
          currId
          isOpen
          degree{
            id
            code
            nameLocal
            nameEng
          }
          faculty{
            id
            code
            nameLocal
            nameEng
          }
          department{
            id
            code
            nameLocal
            nameEng
          }
        }
      }`
    }
  }
};

export const getAssessments = () => {
  return {
    name: "getAssessments",
    ql: {
      query: `
      {
        getAssessments {
          id
          title: nameLocal
          nameLocal
          nameEng
        }
      }`
    }
  }
};

export const getSubjectGroups = () => {
  return {
    name: "getSubjectGroups",
    ql: {
      query: `
      {
        getSubjectGroups {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
        }
      }`
    }
  }
};

export const getSubjects = () => {
  return {
    name: "getSubjects",
    ql: {
      query: `
      {
        getSubjects {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
          description
          creditCalGrade
          creditDesc
          degree{
            id
            code
            nameLocal
            nameEng
          }
          subjectGroup{
            id
            code
            nameLocal
            nameEng
          }
        }
      }`
    }
  }
};

export const getSubjectsBySubjectGroup = (id) => {
  return {
    name: "getSubjectsBySubjectGroup",
    ql: {
      query: `
      {
        getSubjectsBySubjectGroup(
          subjectGroupId: "${id}"
        ) {
          id
          code
          title: nameLocal
          nameLocal
          nameEng
          description
          creditCalGrade
          creditDesc
          degree{
            id
            code
            nameLocal
            nameEng
          }
          subjectGroup{
            id
            code
            nameLocal
          }
        }
      }`
    }
  }
};
